<template>
  <div
    :style="tagStyle"
    :title="title"
  >
    <div
      v-if="icon !== ''"
      :style="{ marginRight: '.6rem'}"
    >
      <c-icon
        :type="icon"
        :color="iconColor"
        size="14"
      />
    </div>
    <div>
      <div :style="titleStyle">
        <div :style="titleInnerStyle">
          {{ title }}
        </div>
      </div>
    </div>
    <div
      v-if="closable"
      :style="{ marginLeft: '.2rem', marginRight: '.2rem', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', width: '2rem', height: '2rem' }"
      @click="$emit('close:click', $event)"
    >
      <c-icon
        type="close"
        size="12"
        :color="$colors.grey.lighten1"
      />
    </div>
    <slot name="suffix" />
  </div>
</template>

<script>
import CIcon from 'shared/components/CIcon.vue';
import colors from 'shared/assets/js/colors';
import { getNotionBackgroundColor, getNotionFontColor } from 'shared/services/notion-colors';

export default {
  name: 'CTag',
  props: {
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    iconColor: {
      type: String,
      default: colors.grey.base,
    },
    color: {
      type: String,
      default: 'default',
    },
    closable: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: String,
      default: '',
    },
  },
  emits: ['close:click'],
  components: { CIcon },
  computed: {
    tagStyle() {
      const middlewares = [this.makePadding];

      const r = {
        display: 'inline-flex',
        alignItems: 'center',
        flexShrink: '1',
        minWidth: '0px',
        height: '2rem',
        borderRadius: '3px',
        paddingLeft: '6px',
        paddingRight: '6px',
        fontSize: this.$fontSizes[4],
        lineHeight: '120%',
        color: this.textColor,
        background: this.backgroundColor,
        margin: '0px',
      };

      return middlewares.reduce((res, next) => next(res), r);
    },
    textColor() {
      if (this.color === 'empty') {
        return this.$colors.grey.lighten2;
      }
      if (this.color === 'plain') {
        return this.$colors.grey.darken4;
      }
      return getNotionFontColor(this.color);
    },
    backgroundColor() {
      if (this.color === 'empty' || this.color === 'plain') {
        return 'transparent';
      }
      return getNotionBackgroundColor(this.color);
    },
    titleInnerStyle() {
      if (this.maxWidth === '') {
        return { display: 'block' };
      }
      return {
        display: 'block',
        maxWidth: this.maxWidth,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      };
    },
    titleStyle() {
      const middlewares = [];

      const r = {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'flex',
        alignItems: 'center',
      };

      return middlewares.reduce((res, next) => next(res), r);
    },
  },
  methods: {
    makePadding(style) {
      if (this.closable) {
        return {
          ...style,
          paddingRight: 0,
        };
      }

      return style;
    },
  },
};
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>

</style>
